const MIN_DECIMALS = 3;
const MAX_DECIMALS = 6;

export const formatWeight = (
  value: number | string | null | undefined,
): string => {
  if (value === null || value === undefined || value === "") return "";

  const numericValue =
    typeof value === "number" ? value : Number.parseFloat(String(value));

  if (Number.isNaN(numericValue)) return "";

  const fixed = numericValue.toFixed(MAX_DECIMALS);
  const [integerPart, decimalPart = ""] = fixed.split(".");

  if (!decimalPart) return integerPart;

  const afterThird = decimalPart.slice(MIN_DECIMALS);
  const useMaxPrecision = afterThird && /[1-9]/.test(afterThird);

  const decimals = useMaxPrecision
    ? decimalPart.replace(/0+$/, "")
    : decimalPart.slice(0, MIN_DECIMALS);

  return decimals ? `${integerPart}.${decimals}` : integerPart;
};
